"use strict";
//#region Functions
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadRemoteConfig = void 0;
function loadRemoteConfig(path) {
    return new Promise((resolve, reject) => {
        fetch(path)
            .then(async (value) => {
            if (value.ok) {
                window.env = await value.json();
                resolve(value);
            }
            else {
                console.error('[Remote Config] Error: %d (%s)', value.status, value.statusText);
                reject(value);
            }
        }, (reason) => {
            console.error('[Remote Config] Error: ', reason);
            throw new Error('Remote config error', { cause: reason });
        })
            .catch((reason) => {
            console.error('[Remote Config] Error: ', reason);
            throw new Error('Remote config error', { cause: reason });
        });
    });
}
exports.loadRemoteConfig = loadRemoteConfig;
//#endregion
//# sourceMappingURL=loadRemoteConfig.js.map